import { Grid } from "@mui/material";
import { DoughnutChart } from "components";
import { useMemo } from "react";

const SharesValueDistributionSection = ({ data }) => {
  const chartData = useMemo(
    () => ({
      labels: [
        `Ownership more than 5%`,
        `Non-affiliated shareholders (public)`,
        `Affiliated shareholders (public)`,
      ],
      datasets: [
        {
          data: [
            data?.ownership_more_than_5_percentage,
            data?.non_affiliated_shareholders_percentage,
            data?.affiliated_shareholders_percentage,
          ],
          backgroundColor: ["#3DA2F3", "#2DC48D", "#FFB703"],
        },
      ],
    }),
    [data],
  );

  return (
    <div className='section'>
      <p className='font-bold text-lg mb-6'>Shares Value Distribution</p>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DoughnutChart
            id='share-value-distribution-percentage-chart'
            data={chartData}
          />
        </Grid>
        <Grid item xs={6}>
          <div className='flex flex-col gap-4'>
            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-2 items-center'>
                <div className='rounded-full w-2 h-2 bg-[#3DA2F3]' />
                <p className='text-[#5F737F] text-sm'>Ownership more than 5%</p>
              </div>
              <p className='pl-4'>{`${data?.ownership_more_than_5_percentage}%`}</p>
            </div>

            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-2 items-center'>
                <div className='rounded-full w-2 h-2 bg-[#2DC48D]' />
                <p className='text-[#5F737F] text-sm'>
                  Non-affiliated shareholders (public)
                </p>
              </div>
              <p className='pl-4'>{`${data?.non_affiliated_shareholders_percentage}%`}</p>
            </div>

            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-2 items-center'>
                <div className='rounded-full w-2 h-2 bg-[#FFB703]' />
                <p className='text-[#5F737F] text-sm'>
                  Affiliated shareholders (public)
                </p>
              </div>
              <p className='pl-4'>{`${data?.affiliated_shareholders_percentage}%`}</p>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default SharesValueDistributionSection;
